import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { MenuId } from 'vscode/vscode/vs/platform/actions/common/actions';
import { RawContextKey } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';

const _moduleId = "vs/workbench/contrib/terminalContrib/chat/browser/terminalChat";
const MENU_TERMINAL_CHAT_INPUT = MenuId.for('terminalChatInput');
const MENU_TERMINAL_CHAT_WIDGET = MenuId.for('terminalChatWidget');
const MENU_TERMINAL_CHAT_WIDGET_STATUS = MenuId.for('terminalChatWidget.status');
const MENU_TERMINAL_CHAT_WIDGET_FEEDBACK = MenuId.for('terminalChatWidget.feedback');
MenuId.for('terminalChatWidget.toolbar');
var TerminalChatContextKeys;
( ((function(TerminalChatContextKeys) {
    TerminalChatContextKeys.focused = ( (new RawContextKey(
        "terminalChatFocus" ,
        false,
        ( localizeWithPath(_moduleId, 0, "Whether the chat view is focused."))
    )));
    TerminalChatContextKeys.visible = ( (new RawContextKey(
        "terminalChatVisible" ,
        false,
        ( localizeWithPath(_moduleId, 1, "Whether the chat view is visible."))
    )));
    TerminalChatContextKeys.requestActive = ( (new RawContextKey(
        "terminalChatActiveRequest" ,
        false,
        ( localizeWithPath(_moduleId, 2, "Whether there is an active chat request."))
    )));
    TerminalChatContextKeys.inputHasText = ( (new RawContextKey(
        "terminalChatInputHasText" ,
        false,
        ( localizeWithPath(_moduleId, 3, "Whether the chat input has text."))
    )));
    TerminalChatContextKeys.agentRegistered = ( (new RawContextKey(
        "terminalChatAgentRegistered" ,
        false,
        ( localizeWithPath(_moduleId, 4, "Whether the terminal chat agent has been registered."))
    )));
    TerminalChatContextKeys.responseContainsCodeBlock = ( (new RawContextKey(
        "terminalChatResponseContainsCodeBlock" ,
        false,
        ( localizeWithPath(_moduleId, 5, "Whether the chat response contains a code block."))
    )));
    TerminalChatContextKeys.responseContainsMultipleCodeBlocks = ( (new RawContextKey(
        "terminalChatResponseContainsMultipleCodeBlocks" ,
        false,
        ( localizeWithPath(_moduleId, 6, "Whether the chat response contains multiple code blocks."))
    )));
    TerminalChatContextKeys.responseSupportsIssueReporting = ( (new RawContextKey(
        "terminalChatResponseSupportsIssueReporting" ,
        false,
        ( localizeWithPath(_moduleId, 7, "Whether the response supports issue reporting"))
    )));
    TerminalChatContextKeys.sessionResponseVote = ( (new RawContextKey(
        "terminalChatSessionResponseVote" ,
        undefined,
        { type: 'string', description: ( localizeWithPath(
            _moduleId,
            8,
            "When the response has been voted up, is set to 'up'. When voted down, is set to 'down'. Otherwise an empty string."
        )) }
    )));
})(TerminalChatContextKeys || (TerminalChatContextKeys = {}))));

export { MENU_TERMINAL_CHAT_INPUT, MENU_TERMINAL_CHAT_WIDGET, MENU_TERMINAL_CHAT_WIDGET_FEEDBACK, MENU_TERMINAL_CHAT_WIDGET_STATUS, TerminalChatContextKeys };
